import { NumberRange } from 'util/number/number-in-range'
import { getProcedimentosConsideradosTooltipText } from 'view/acompanhamento/acompanhamento-condicao-saude/utils-acompanhamentoCondicaoSaude'

const title = {
  plural: 'Exames considerados',
  singular: 'Exame considerado',
}

export const EXAMES_HIV_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  [
    'Teste rápido para detecção de HIV na gestante ou pai/parceiro (0214010040)',
    'Teste rápido para detecção de infecção pelo HIV (0214010058)',
    'Pesquisa de anticorpos ANTI-HIV-1 (western blot) (0202030296)',
    'Pesquisa de HIV-1 por imunofluorescência (0202031020)',
    'Detecção de ácidos nucleicos do HIV-1 (Qualitativo) (0202030040)',
    'Quantificação de RNA do HIV-1 (0202031071)',
    'Pesquisa de anticorpos ANTI-HIV-1 + HIV-2 (elisa) (0202030300)',
    'Determinação de carga viral do HIV por rt-pcr (0213010011)',
    'Quantificação da carga viral do HIV (RNA) (0213010500)',
  ],
  title
)

export const EXAMES_SIFILIS_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  [
    'Teste rápido para sífilis na gestante ou pai/parceiro (0214010082)',
    'Teste treponêmico p/ detecção de sífilis (0202031098)',
    'Teste FTA-ABS IGG p/ diagnóstico da sífilis (0202031128)',
    'Teste FTA-ABS IGM p/ diagnóstico da sífilis (0202031136)',
    'Teste não treponêmico p/ detecção de sífilis em gestantes (0202031179)',
    'Teste rápido para sífilis (0214010074)',
    'Administração de penicilina para tratamento de sífilis (0301100241)',
    'Teste não treponemico p/ detecção de sifilis (0202031110)',
  ],
  {
    plural: 'Exames/procedimentos considerados',
    singular: 'Exame/procedimento considerado',
  }
)

export const EXAMES_HEPATITE_B_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  [
    'Pesquisa de antígeno e do vírus da hepatite B (HBEAG) (0202030989)',
    'Identificação do vírus da hepatite B por pcr (quantitativo) (0213010208)',
    'Pesquisa de anticorpos IGM contra antígeno central do vírus da hepatite B (Anti-HBC-IGM) (0202030890)',
    'Pesquisa de anticorpos contra antígeno de superfície do vírus da hepatite B (Anti-HBS) (0202030636)',
    'Pesquisa de anticorpos contra antígeno e do vírus da hepatite B (Anti-HBE) (0202030644)',
    'Pesquisa de anticorpos IGG e IGM contra antígeno central do vírus da hepatite B (Anti-HBC-total) (0202030784)',
    'Pesquisa de antígeno de superfície do vírus da hepatite B (HBSAG) (0202030970)',
  ],
  title
)

export const EXAMES_HEPATITE_C_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  [
    'Pesquisa de anticorpos contra o vírus da hepatite C (Anti-HCV) (0202030679)',
    'Teste rápido para detecção de hepatite c (0214010090)',
    'Detecção de RNA do vírus da hepatite C (Qualitativo) (0202030059)',
    'Quantificação de RNA do vírus da hepatite C (0202031080)',
  ],
  title
)

export const EXAMES_CANCER_MAMA_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  ['Mamografia bilateral para rastreamento (0204030188)'],
  title
)

export const EXAMES_CANCER_COLO_UTERO_TOOLTIP_TEXT = getProcedimentosConsideradosTooltipText(
  [
    'Exame citopatológico cérvico vaginal/microflora-rastreamento (0203010086)',
    'Exame citopatológico cérvico-vaginal/microflora (0203010019)',
    'Coleta de material do colo do útero para exame molecular de detecção de HPV (0201020076)',
    'Entrega de material obtido por auto coleta para exame molecular para detecção de HPV, no colo do útero (0201020084)',
    'Coleta de material do colo de útero para exame citopatológico (0201020033)',
  ],
  title
)

export const RANGE_IDADE_RASTREIO_CANCER_COLO_UTERO: NumberRange = {
  min: 25,
  max: 64,
}

export const RANGE_IDADE_RASTREIO_CANCER_MAMA: NumberRange = {
  min: 50,
  max: 69,
}

export const RANGE_IDADE_RASTREIO_SAUDE_SEXUAL_REPRODUTIVA: NumberRange = {
  min: 14,
  max: 69,
}
